import React from 'react';
import { useTranslation } from 'react-i18next';
import { AgencyCard } from '../../Cards/AgencyCard';
import { AgenciesQuery } from '../../../graphql/graphql';
import { AgencyListContainer } from './styled';
import { BusinessItemsListPageWrapper } from '../../BusinessItemsListPage';

interface AgenciesListProps {
  agencies: AgenciesQuery['agencies'];
  hasError: boolean;
}

export const AgenciesList: React.FC<AgenciesListProps> = ({
  agencies,
  hasError
}) => {
  const { t } = useTranslation();

  const title = t('pages.agencies.title');

  return (
    <BusinessItemsListPageWrapper
      title={title}
      hasError={hasError}
      items={agencies}
      CardComponent={AgencyCard}
      ListContainer={AgencyListContainer}
    />
  );
};
